import '@popperjs/core';
import 'bootstrap';
import 'htmx.org';
import htmx from 'htmx.org';
(window as any).htmx = htmx;
